import { render, staticRenderFns } from "./NotificationAnnouncement.vue?vue&type=template&id=00f1bc9c&scoped=true"
import script from "./NotificationAnnouncement.vue?vue&type=script&lang=js"
export * from "./NotificationAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./NotificationAnnouncement.vue?vue&type=style&index=0&id=00f1bc9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1bc9c",
  null
  
)

export default component.exports